import { UserMainAccountModel } from '@api-model/account';
import { AccountFeatureFlagModel } from '@hwm/ui-lib';
import { httpClient } from '@infrastructure/http/HttpClient';
import { apiPaths } from '@infrastructure/http/apiPaths';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

export const getUserProfile = createAsyncThunk(`userProfile/getUserProfile`, async () => {
  const response: AxiosResponse<UserMainAccountModel> = await httpClient.get(apiPaths.accounts.profile);
  return response.data;
});

export const getUserPermissions = createAsyncThunk(`userProfile/getUserPermissions`, async () => {
  const response: AxiosResponse<string[]> = await httpClient.get(apiPaths.accounts.permissions);
  return response.data;
});

export const getTopLvlFeatureFlags = createAsyncThunk(`userProfile/getFeatureFlags`, async () => {
  const response: AxiosResponse<AccountFeatureFlagModel[]> = await httpClient.get(apiPaths.featureFlags.features);
  return response.data;
});

export const userProfileThunks = {
  getUserProfile,
  getUserPermissions,
  getTopLvlFeatureFlags,
};
